import type { ApplePayLineItem } from 'braintree-web';
import type { ApplePayShippingMethod } from '../../typings/apple.types';
import type { ActiveBasketSummaryData } from '../../typings/basket.types';

const getLineItems = (
    basket: ActiveBasketSummaryData,
    selectedShippingMethod?: ApplePayShippingMethod,
): ApplePayLineItem[] => {
    const subtotal = { label: 'Subtotal', amount: basket.totalItemPrice.toString() };
    const discount = basket.promoTotal ? { label: 'Discount', amount: basket.promoTotal.toString() } : null;
    const shipping = {
        label: 'Shipping',
        amount: selectedShippingMethod ? selectedShippingMethod.amount : '0',
    };
    const tax = selectedShippingMethod ? parseFloat(selectedShippingMethod.tax) : 0;

    const taxItem = tax ? { label: 'Tax', amount: tax.toString() } : null;

    return [subtotal, taxItem, shipping, discount].filter(Boolean) as ApplePayLineItem[];
};

export default getLineItems;
